import { useMemo } from "react";
import { CircularProgress, IconButton as MuiIconButton } from "@mui/material";
import { getButtonColors } from "./util";

export default function IconButton({
    size,
    color,
    variant,
    sx,
    textColor,
    bgColor,
    loading,
    children,
    disabled,
    ...props
}) {
    const { text, bg, border, shadow } = useMemo(
        () => getButtonColors(color, variant, { text: textColor, bg: bgColor }),
        [color, variant, textColor, bgColor],
    );

    return (
        <MuiIconButton
            {...props}
            disabled={disabled || loading}
            sx={{
                backgroundColor: bg,
                color: text,
                border: `1px solid ${border}`,
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s",

                width: size ?? "44px",
                height: size ?? "44px",

                "&:hover": {
                    backgroundColor: variant === "text" ? shadow : bg,
                    boxShadow: `0 1px 8px ${shadow}`,
                    scale: "1.05",
                },

                "&:active": {
                    scale: "0.95",
                },

                ...sx,
            }}
        >
            {loading ? (
                <CircularProgress size={20} sx={{ color: text }} />
            ) : (
                children
            )}
        </MuiIconButton>
    );
}
